import { render, staticRenderFns } from "./UsersListAdmin.vue?vue&type=template&id=83f99de4&scoped=true&"
import script from "./UsersListAdmin.vue?vue&type=script&lang=js&"
export * from "./UsersListAdmin.vue?vue&type=script&lang=js&"
import style0 from "./UsersListAdmin.vue?vue&type=style&index=0&id=83f99de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f99de4",
  null
  
)

export default component.exports